module.exports = __webpack_public_path__ + "img/password-icon.5be2b505.svg";